// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__T-WS4","boxTitle":"Qualiphy_boxTitle__2CuLE","box":"Qualiphy_box__1eDBa","toggleWrap":"Qualiphy_toggleWrap__1iGRX"};